<template>
  <div class="segment-actions-container v2">
    <div v-if="type == 'segments'" class="conditionsHeader sectionPadding">
      <span class="condition-header">Select condition</span>
      <VIcon name="close-line" @click="onClickClose" class="btn-close-action cursorPointer"></VIcon>
    </div>
    <div class="accordion-wrapper" :class="{'broadcast_conditions': type == 'broadcast'}">
      <!-- Last Interaction -->
      <div class="accordion-section">
        <div class="accordion-header" @click="toggleSection('lastInteraction')">
          <span class="sidebar-title">Last Interaction</span>
          <VIcon :name="openSections.lastInteraction ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
        </div>
        <transition name="accordion-slide">
          <div v-if="openSections.lastInteraction" class="accordion-content">
            <div class="list-container child-items" v-for="item in lastInteractionOptionsToLoad" :key="item.name" @click="onClickOption($event, item)">
              <VIcon :name="item.img" class="conditionIcon"></VIcon>
              <a href="#" :title="item.name" class="condition-link">{{ item.name }}</a>
            </div>
          </div>
        </transition>
      </div>

      <!-- Personal Details -->
      <div class="accordion-section">
        <div class="accordion-header" @click="toggleSection('personalDetails')">
          <span class="sidebar-title">Personal Details</span>
          <VIcon :name="openSections.personalDetails ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
        </div>
        <transition name="accordion-slide">
          <div v-if="openSections.personalDetails" class="accordion-content">
            <div class="list-container child-items" v-for="item in personalDetailsOptions" :key="item.name" @click="onClickOption($event, item)">
              <VIcon :name="item.img" class="conditionIcon"></VIcon>
              <a href="#" :title="item.name" class="condition-link">{{ item.name }}</a>
            </div>
          </div>
        </transition>
      </div>

      <!-- Tags and Custom Data -->
      <div class="accordion-section">
        <div class="accordion-header" @click="toggleSection('customData')">
          <span class="sidebar-title">Tags and Custom Data</span>
          <VIcon :name="openSections.customData ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
        </div>
        <transition name="accordion-slide">
          <div v-if="openSections.customData" class="accordion-content">
            <div class="list-container child-items" v-for="item in customOptions" :key="item.name" @click="onClickOption($event, item)">
              <VIcon :name="item.img" class="conditionIcon"></VIcon>
              <a href="#" :title="item.name" class="condition-link">{{ item.name }}</a>
            </div>
          </div>
        </transition>
      </div>

      <!-- Broadcast -->
      <div class="accordion-section">
        <div class="accordion-header" @click="toggleSection('broadcast')">
          <span class="sidebar-title">Broadcast</span>
          <VIcon :name="openSections.broadcast ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
        </div>
        <transition name="accordion-slide">
          <div v-if="openSections.broadcast" class="accordion-content">
            <div class="list-container child-items" v-for="item in broadcastOptions" :key="item.name" @click="onClickOption($event, item)">
              <VIcon :name="item.img" class="conditionIcon"></VIcon>
              <a href="#" :title="item.name" class="condition-link">{{ item.name }}</a>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { CONDITION_TYPE } from "./segmentConstants.js";

export default {
  emits: ['close', 'actionClick'],
  data() {
    return {
      CONDITION_TYPE,
      openSections: {
        lastInteraction: true,
        personalDetails: false,
        customData: false,
        broadcast: false,
      },
      lastInteractionOptions: [
        {
          name: CONDITION_TYPE.INTERACTION_DATE,
          img: 'calendar-line',
        },
        {
          name: CONDITION_TYPE.INTERACTION_TIME,
          img: 'clock-line',
        },
        {
          name: CONDITION_TYPE.LAST_REPLY_DATE,
          img: 'calendar-check-line',
        },
        {
          name: CONDITION_TYPE.INTERACTION_CHANNEL,
          img: 'bot-line',
        },
        {
          name: CONDITION_TYPE.TALKED_WITH_AGENT,
          img: 'receptionist-line',
        },
        {
          name: CONDITION_TYPE.ENGAGED_WITH_BOT_FLOW,
          img: 'bot-line',
        },
      ],
      personalDetailsOptions: [
        {
          name: CONDITION_TYPE.NAME,
          img: 'user-line',
        },
        {
          name: CONDITION_TYPE.EMAIL,
          img: 'mailbox-line',
        },
        {
          name: CONDITION_TYPE.NUMBER,
          img: 'call-line',
        },
        {
          name: CONDITION_TYPE.GENDER,
          img: 'gender-unspecified-line',
        },
      ],
      customOptions: [
        {
          name: CONDITION_TYPE.TAGS,
          img: 'hash-line',
        },
        {
          name: CONDITION_TYPE.CUSTOM_FIELD,
          img: 'inbox-3-line',
        },
      ],
      broadcastOptions: [
        {
          name: CONDITION_TYPE.DLR_STATUS,
          img: 'message-sent-line',
        },
        {
          name: CONDITION_TYPE.BROADCAST_INTERACTION_STATUS,
          img: 'click-to-call-line',
        },
      ]
    };
  },
  props: {
    segmentQueryString: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: 'broadcast'
    }
  },
  computed: {
    lastInteractionOptionsToLoad() {
      let options = [];
      this.lastInteractionOptions.forEach((elm) => {
        let isChannelIncluded = this.segmentQueryString.includes("platform=")
        if ( isChannelIncluded && elm.name == CONDITION_TYPE.INTERACTION_CHANNEL) {
          return;
        }
        elm.name !== CONDITION_TYPE.INTERACTION_CHANNEL ? options.push(elm) : 0;
      })
      return options;
    }
  },
  methods: {
    toggleSection(section) {
      const isOpen = this.openSections[section];
      // Close all sections first
      Object.keys(this.openSections).forEach(key => {
        this.openSections[key] = false;
      });
      // Toggle the clicked section (if it was closed, open it)
      if (!isOpen) {
        this.openSections[section] = true;
      }
    },
    onClickClose() {
      this.$emit('close');
    },
    onClickOption($event, option) {
      $event.preventDefault();
      this.$emit('actionClick', option);
    }
  },
};
</script>

<style scoped>
.child-items {
  border-radius: 5px;
  background: var(--background-primary);
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 12px 0;
}
.child-items .conditionIcon {
  padding: 0 15px;
}
.btn-close-action {
  width: 25px;
  height: 25px;
}
.conditionsHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--background-primary);
}
.sidebar-title {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  color: var(--black);
}
.condition-link {
  text-decoration: none;
  color: var(--black);
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
.condition-link:hover {
  color: var(--purple);
}
.condition-header {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
}
.sectionPadding {
  padding: 20px;
}
.accordion-wrapper {
  padding: 10px 20px;
}
.conditionIcon {
  color: var(--black);
}
.broadcast_conditions {
  padding: 10px 20px 20px 10px;
}

/* Custom accordion */
.accordion-section {
  margin-bottom: 4px;
}
.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid var(--background-primary);
}
.accordion-header:hover {
  opacity: 0.8;
}
.accordion-content {
  padding: 10px 0;
  overflow: hidden;
}

/* Slide transition */
.accordion-slide-enter-active,
.accordion-slide-leave-active {
  transition: all 0.25s ease;
  max-height: 500px;
  opacity: 1;
}
.accordion-slide-enter-from,
.accordion-slide-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
